import Constants from '../constants'
import axios from "axios";

const state = {
    loading: false,
    assignedUsers: [],
    noUsersAvailable: false,
    error: null,
};

const getters =  {
    assignedUsers(state) {
        const users = state.assignedUsers;
        users.sort((a,b) => {
            let totala = 0;
            for (var keya in a.answers) 
                if(a.answers[keya] > 0)
                    totala++
            let totalb = 0;
            for (var keyb in b.answers) 
                if(b.answers[keyb] > 0)
                    totalb++
            return totalb - totala;
        })

        return users
    },

    noUsersAvailable(state) {
        return state.noUsersAvailable
    },
    loading(state) {
        return state.loading;
    },
    error(state) {
        return state.error;
    },
}


const mutations = {
    setAssignedUsers(state, payload) {
        state.assignedUsers = payload;
    },
    setNoUsersAvailable(state, payload) {
        state.noUsersAvailable = payload;
    },
    setLoading(state, payload) {
        state.loading = payload;
    },
    setError(state, payload) {
        state.error = payload;
    },
    clearError(state) {
        state.error=null;
    },
}

const actions = {
    async loadAssignedUser({commit}) {
        commit('setLoading', true);
        axios.get(Constants.apiBaseURL+'dashboard/users/get-assigned-patients', {})
            .then(response => {
                commit('setLoading', false);
                const users = response['data']['data'][0];

                commit('setAssignedUsers',  users);
                commit('setLoading', false);
            })
            .catch(error => {
                commit('setLoading', false);
                commit('setError', error);
            });
    },

    async requestNewPatients({commit}) {
        commit('setLoading', true)
        commit('setNoUsersAvailable', false)
        commit('setAssignedUsers',  []);
        axios.post(Constants.apiBaseURL+'dashboard/users/request-new-patients', {})
            .then(response => {
                commit('setLoading', false);
                const users = response['data']['data'][0];
                if (users.length>0) {
                    commit('setNoUsersAvailable', false)
                    commit('setAssignedUsers',  users);
                } else {
                    commit('setNoUsersAvailable', true)
                }
            })
            .catch(error => {
                commit('setLoading', false)
                commit('setNoUsersAvailable', false)
                commit('setError', error);
            });
    },

    clearError({commit}) {
        commit('clearError');
    },
}

export default {
    namespaced: true,
    state,
    getters, 
    mutations,
    actions
}

